/**
 * Helper to listen for bootstrap page breakpoints
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/* global App */

import SimpleBreakpoints from 'simple-breakpoints'

export default class Breakpoints {
  constructor (breakpoints) {
    this.breakpoints = breakpoints || {
      'mobile': 613,
      'tablet': 613,
      'small_desktop': 919,
      'large_desktop': 1191
    }

    this.map = {
      'mobile': 'xs',
      'tablet': 'sm',
      'small_desktop': 'md',
      'large_desktop': 'lg'
    }

    this.handler = new SimpleBreakpoints(this.breakpoints)

    this.handler.on('breakpointChange', (from, to) => {
      App.dispatcher.fire('breakpoint.' + this.map[to])
      App.dispatcher.fire('breakpoint', {
        from: this.map[from],
        to: this.map[to]
      })
    })

    let current = this.handler.currentBreakpoint()
    App.dispatcher.fire('breakpoint.' + this.map[current])
  }
}
